import { render, staticRenderFns } from "./Departemens.vue?vue&type=template&id=7b354e54&"
import script from "./Departemens.vue?vue&type=script&lang=js&"
export * from "./Departemens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports